import { render } from "./StatsHeader.vue?vue&type=template&id=ee6361d0"
import script from "./StatsHeader.vue?vue&type=script&lang=js"
export * from "./StatsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__